import api from "./api"

export const getStockBalances = async () => {
  const response = await api.get("/stock-balances")
  return response.data
}

export const getStockBalanceById = async (stockBalanceId) => {
  const response = await api.get(`/stock-balances/${stockBalanceId}`)
  return response.data
}

export const getStockBalanceFormData = async () => {
  const response = await api.get("/stock-balances/form-data")
  return response.data
}

export const createStockBalance = async (payload) => {
  const response = await api.post("/stock-balances", payload)
  return response.data
}

export const updateStockBalance = async (stockBalanceId, payload) => {
  const response = await api.put(`/stock-balances/${stockBalanceId}`, payload)
  return response.data
}

export const deleteStockBalance = async (stockBalanceId) => {
  const response = await api.delete(`/stock-balances/${stockBalanceId}`)
  return response.data
}